import axios from 'axios';
import moment from 'moment';

const hours = {
  namespaced: true,
  state: {
    site: undefined,
    weekStart: undefined,
    applicableHours: undefined,
    current: undefined
  },

  actions: {
    CLEAR({commit}) {
      commit('clear');
    },

    GET_OPEN({rootGetters, commit}, store_id) {
      return axios.get(process.env.VUE_APP_API_BASE + `/sites/${store_id}/simple-opening-hours?api_key=${rootGetters.key}`)
        .then((res) => {
          commit('setCurrent', res.data[0]);
        }).catch((err) => {
          console.error('Unable to get opening hours',err);
        });
    },

    async GET_HOURS({rootGetters, commit}, store_id) {

      return await axios.get(process.env.VUE_APP_API_BASE + '/a/user?api_key=' + rootGetters.key)
        .then((res) => {
          const site = res.data.sites.find(s => s.id === parseInt(store_id));
          commit('setWeekStart', res.data.customer.first_day_of_week);
          commit('setSite', site);
          return site;

        })
        .then((site) => {
          let now = moment().toISOString();

          let applicable = site.new_opening_hours.filter((h) => {
            let f = h.from ? moment(h.from) : h.from;
            let t = h.to ? moment(h.to) : h.to;

            if ((f === null || f.isSameOrBefore(now)) && (t === null || t.isSameOrAfter(now))) {
              return h;
            }
          });

          if (applicable.length > 1) {
            // Check if there's an entry where both FROM and TO are null, add and map index.
            let nullIndexes = applicable.filter((h, i) => {
              if (h.from === null && h.to === null) {
                h.index = i;
                return h;
              }
            }).map(h => h.index);
            if (nullIndexes.length > 0 && nullIndexes.length < applicable.length) {
              // Remove entries where both FROM and TO are NULL starting at the END of the applicable array.
              for (let i = nullIndexes.length; i > 0; i--) {
                applicable = applicable.slice(nullIndexes);
              }
            }
          }

          commit('setHours', applicable);
        });
    },

    DETERMINE_INTERVAL({rootGetters, getters, commit}) {
      const now = moment();

      if (getters.isOpen(now)) {
        // When the store is open, check if the interval is set correctly if not set it.
        if (rootGetters.interval !== process.env.VUE_APP_ENDPOINT_DEFAULT_REFRESH_INTERVAL) {
          commit('setInterval', process.env.VUE_APP_ENDPOINT_DEFAULT_REFRESH_INTERVAL, {root: true});
        }

      } else {
        // Default to 1 hour.
        let newInterval = 3600000;

        let nextOpening = getters.opensAt(now);
        if (nextOpening) {
          // Increase interval as opening hour approaches
          // Decreasing the chance of displaying 'closed' while the store's open.

          // get time to next opening in minutes;
          let diff = nextOpening.diff(now, 'minutes');
            // 1 minute or less time to next opening
            if ([0,1].includes(diff)) {
              newInterval = process.env.VUE_APP_ENDPOINT_DEFAULT_REFRESH_INTERVAL; // Set to default refresh interval

              // 10 minutes ore less to next opening
            } else if (diff <= 10) {
              newInterval = 60000; // Set to every 1 minute

              // 1 hour or less time to next opening
            } else if (diff <= 60) {
              newInterval = 300000; // Set to every 5 minutes
            }
        }

        if (rootGetters.interval !== newInterval) {
          commit('setInterval', newInterval, {root: true});
        }
      }
    }
  },

  mutations: {
    clear(state) {
      state.site = undefined;
      state.applicableHours = undefined;
    },

    setWeekStart(state, start) {
      state.weekStart = start;
    },

    setSite(state, site) {
      state.site = site;
    },

    setHours(state, data) {
      state.applicableHours = data;
    },
    setCurrent(state, data) {
      state.current = data;
    }
  },

  getters: {

    weekStart: (state) => {
      return state.weekStart;
    },

    openingHours: (state) => {
      if (state.applicableHours) {
        let days = {};
        for (let i = 0; i < state.applicableHours.length; i++) {
          for (let key in state.applicableHours[i].weekdays) {
            if (days[key] === undefined) days[key] = [];
            days[key].push(state.applicableHours[i].weekdays[key]);
          }
        }
        return days;
      }
    },

    isOpen: (state) => (now) => {
      if (!now || !state.current) return false;
      let start = moment(state.current.open);
      let end = moment(state.current.close);
      return now.isBetween(start,end);
    },

    opensAt: (state, getters) => (now) => {
      const today = now.format('YYYY-MM-DD');
      const day = now.format('dddd').toLowerCase();

      const hours = getters.openingHours ? getters.openingHours[day].map(h => h.opening_time).sort((a,b) => {
        return b > a ? -1 : 0;
      }) : [];

      let x = undefined;
      for (let i = 0; i < hours.length; i++) {
        if (hours[i] === null) continue;

        x = moment(`${today} ${hours[i]}`);
        if (now.isBefore(x)) break;
      }

      return x;
    },
  }
};

export default hours;